import { SvgProps } from "@/utils/types";

export const Pan = ({
  className,
  primaryColor,
  secondaryColor,
  outlineColor,
}: SvgProps) => {
  return (
    <svg
      width="122"
      height="79"
      viewBox="0 0 122 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_381_1348)">
        <path
          d="M79.657 40.5427C79.5856 40.2999 79.4213 40.0999 79.1928 39.9785C79.0499 39.9 78.9 39.8643 78.7429 39.8643C78.65 39.8643 78.5572 39.8785 78.4643 39.9071L3.8921 62.3316C3.38505 62.4816 3.09939 63.0172 3.24936 63.5243L3.88496 65.6382C6.14884 73.1654 14.1117 77.4432 21.6389 75.1793L70.7443 60.4105C74.3936 59.3107 77.3931 56.8612 79.1928 53.5118C80.9924 50.1553 81.3852 46.3059 80.2854 42.6566L79.6498 40.5427H79.657ZM67.7448 57.8253C67.1735 57.9967 65.938 58.2824 65.938 57.9396C71.4085 53.6903 74.6293 50.4123 76.0291 43.6921C76.1933 43.3565 76.4576 43.5422 76.4933 43.6564C78.4143 50.0338 74.4865 55.7971 67.7448 57.8253Z"
          fill={primaryColor || "#CAC0FC"}
        />
        <path
          d="M116.258 34.6652C116.865 34.4938 117.365 34.101 117.679 33.5511C117.829 33.2868 117.922 33.0012 117.964 32.7084L84.1705 42.1138L84.5562 43.4921L116.265 34.6723L116.258 34.6652Z"
          fill={secondaryColor || "#F96E09"}
        />
        <path
          d="M118.172 29.309L82.5708 39.2143C82.6279 39.3429 82.6922 39.4714 82.7351 39.6071L83.0779 40.7426L118.607 30.8587C118.971 30.7587 119.343 30.9729 119.443 31.33C120.028 33.4368 118.793 35.6221 116.686 36.2077L84.0848 45.2775C84.0848 45.2775 84.0634 45.2775 84.0491 45.2775C84.092 45.8203 84.1134 46.3559 84.1134 46.8915C84.2491 46.8772 84.3848 46.8558 84.5204 46.8201L117.122 37.7503C118.557 37.3504 119.75 36.422 120.478 35.1222C121.207 33.8296 121.392 32.3227 120.992 30.8872C120.657 29.6732 119.393 28.959 118.179 29.2947L118.172 29.309Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M84.0491 45.2846C84.0491 45.2846 84.0706 45.2846 84.0848 45.2846L116.686 36.2148C118.793 35.6292 120.028 33.4439 119.443 31.3371C119.343 30.9729 118.964 30.7658 118.607 30.8658L83.0779 40.7497L83.3707 41.7353C83.7278 42.9208 83.9492 44.1063 84.0491 45.2918V45.2846ZM117.957 32.7083C117.922 33.0011 117.822 33.2868 117.672 33.551C117.365 34.1009 116.857 34.4937 116.25 34.6651L84.5419 43.4849L84.1563 42.1066L117.95 32.7012L117.957 32.7083Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M20.7029 39.9879L16.6632 42.1259C16.1368 42.4045 15.9359 43.0571 16.2145 43.5835L18.3525 47.6232C18.6311 48.1496 19.2837 48.3505 19.8101 48.0719L23.8498 45.9339C24.3762 45.6553 24.5771 45.0027 24.2985 44.4763L22.1605 40.4366C21.8819 39.9102 21.2293 39.7093 20.7029 39.9879Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M7.74549 15.7363L5.40035 19.6594C5.09477 20.1706 5.26145 20.8327 5.77265 21.1383L9.69575 23.4834C10.207 23.789 10.8691 23.6223 11.1747 23.1111L13.5198 19.188C13.8254 18.6768 13.6587 18.0147 13.1475 17.7091L9.2244 15.364C8.71321 15.0584 8.05107 15.2251 7.74549 15.7363Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M14.3545 29.2305C10.241 27.6307 5.61323 29.6661 4.01352 33.7796C2.41381 37.8932 18.4681 30.8302 14.3545 29.2305Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M38.4359 24.7312L40.0785 10.2624C36.0863 9.80536 32.4799 12.6763 32.0228 16.6755C31.5657 20.6677 34.4366 24.2742 38.4359 24.7312Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M13.519 10.4053L14.3402 11.0552C14.9473 11.5337 15.8328 11.4266 16.3113 10.8195L18.5752 7.94148C20.2177 8.91273 21.7318 9.14126 22.8173 7.76294C24.2527 5.94898 23.5957 3.04951 21.3604 1.28554C19.1251 -0.478424 16.1542 -0.435574 14.7259 1.38552C13.6332 2.77099 14.2188 4.18502 15.54 5.5562L13.2761 8.43425C12.7977 9.04128 12.9048 9.92684 13.5118 10.4053H13.519Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M23.2743 25.3454L19.825 21.9675C19.0965 21.2533 17.9182 21.2676 17.204 21.996L16.2327 22.9887C15.5186 23.7172 15.5329 24.8955 16.2613 25.6097L19.7107 28.9876C18.211 31.0016 17.6896 32.9512 19.3465 34.5795C21.5246 36.7148 25.4168 36.2649 28.0449 33.5868C30.673 30.9087 31.0301 27.0023 28.8519 24.867C27.195 23.2458 25.2525 23.81 23.2743 25.3526V25.3454Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M46.0917 35.9364L49.1483 36.9362C51.1265 30.9087 46.1488 26.2952 45.9417 26.1024L43.7778 28.4734C43.9278 28.6091 47.42 31.9014 46.0988 35.9364H46.0917Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M5.65613 51.8906C5.61328 51.6906 4.57775 47.0058 7.93429 44.4205L5.9775 41.871C0.949836 45.7417 2.46385 52.3548 2.52812 52.6333L5.65613 51.8906Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M25.0241 17.8396C26.1442 17.8396 27.0523 16.9316 27.0523 15.8114C27.0523 14.6913 26.1442 13.7832 25.0241 13.7832C23.9039 13.7832 22.9958 14.6913 22.9958 15.8114C22.9958 16.9316 23.9039 17.8396 25.0241 17.8396Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M33.5439 35.9221C33.5439 37.0434 34.4509 37.9503 35.5721 37.9503C36.6934 37.9503 37.6004 37.0434 37.6004 35.9221C37.6004 34.8009 36.6934 33.8939 35.5721 33.8939C34.4509 33.8939 33.5439 34.8009 33.5439 35.9221Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M82.7778 46.6202C82.2422 46.3202 81.8637 45.8275 81.6995 45.2419L80.8211 42.0853C80.6568 41.4997 80.7354 40.8784 81.0353 40.3428C81.3353 39.8143 81.828 39.4286 82.4136 39.2644L82.5779 39.2215C82.2137 38.336 81.5781 37.6075 80.7211 37.1433C79.7427 36.6149 78.6143 36.5006 77.5431 36.822L2.97084 59.2536C0.771239 59.9178 -0.485677 62.2459 0.178489 64.4455L0.814088 66.5594C3.08511 74.1081 10.041 79 17.5468 78.9929C19.2108 78.9929 20.8962 78.7572 22.5673 78.2502L71.6727 63.4814C79.1714 61.2247 84.0419 54.3474 84.1062 46.8987C84.0348 46.8987 83.9633 46.913 83.8919 46.913C83.5063 46.913 83.1206 46.813 82.7707 46.613L82.7778 46.6202ZM79.1999 53.5047C77.4002 56.8612 74.4008 59.3108 70.7514 60.4034L21.646 75.1722C14.1188 77.436 6.15598 73.1511 3.8921 65.631L3.2565 63.5171C3.10653 63.0101 3.39219 62.4745 3.89924 62.3245L78.4715 39.8928C78.5643 39.8643 78.6572 39.85 78.75 39.85C78.9071 39.85 79.0571 39.8857 79.1999 39.9643C79.4285 40.0857 79.5927 40.2856 79.6641 40.5284L80.2997 42.6423C81.3995 46.2845 81.0067 50.141 79.2071 53.4975L79.1999 53.5047Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M83.2492 44.8133L82.3708 41.6496C82.2708 41.2853 82.485 40.914 82.8421 40.814L83.0778 40.7497L82.735 39.6142C82.6921 39.4785 82.6279 39.35 82.5707 39.2214L82.4065 39.2643C81.8209 39.4285 81.3281 39.8142 81.0282 40.3427C80.7282 40.8783 80.6497 41.4925 80.8139 42.0852L81.6923 45.2418C81.8566 45.8345 82.2422 46.3202 82.7707 46.6201C83.1206 46.8201 83.5063 46.92 83.8919 46.92C83.9633 46.92 84.0348 46.9129 84.1062 46.9058C84.1062 46.3701 84.0919 45.8274 84.0419 45.2918C83.692 45.3703 83.3349 45.1632 83.242 44.8133H83.2492Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M82.3708 41.6496L83.2492 44.8133C83.3492 45.1632 83.6991 45.3632 84.0491 45.2918C83.9491 44.1063 83.7277 42.9136 83.3706 41.7353L83.0778 40.7498L82.8422 40.814C82.4779 40.914 82.2708 41.2925 82.3708 41.6496Z"
          fill={outlineColor || "#540389"}
        />
        <path
          d="M76.0362 43.685C74.6365 50.4052 71.4156 53.6832 65.9452 57.9324C65.9452 58.2823 67.1735 57.9967 67.752 57.8181C74.4936 55.7899 78.4215 50.0267 76.5004 43.6493C76.4647 43.535 76.2005 43.3493 76.0362 43.685Z"
          fill={outlineColor || "#540389"}
        />
      </g>
      <defs>
        <clipPath id="clip0_381_1348">
          <rect width="121.2" height="79" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
